import useAutoNotificationRequest from '@/hooks/useAutoNotificationRequest';

/**
 * Componente invisible que maneja la solicitud automática de notificaciones
 * Se renderiza solo cuando el usuario está autenticado
 */
const AutoNotificationHandler = () => {
  useAutoNotificationRequest();
  return null;
};

export default AutoNotificationHandler;
